const NOTIFICATION_PERMISSION_KEY = "duas-vidas-notification-permission";
const NOTIFICATION_ASKED_KEY = "duas-vidas-notification-asked";

export type NotificationPermissionStatus = "granted" | "denied" | "not-asked";

export const hasAskedNotificationPermission = (): boolean => {
  return localStorage.getItem(NOTIFICATION_ASKED_KEY) === "true";
};

export const setNotificationPermissionAsked = (): void => {
  localStorage.setItem(NOTIFICATION_ASKED_KEY, "true");
};

export const saveNotificationPermission = (granted: boolean): void => {
  localStorage.setItem(NOTIFICATION_PERMISSION_KEY, granted ? "granted" : "denied");
  setNotificationPermissionAsked();
};

export const getNotificationPermission = (): NotificationPermissionStatus => {
  const permission = localStorage.getItem(NOTIFICATION_PERMISSION_KEY);
  
  if (permission === "granted") return "granted";
  if (permission === "denied") return "denied";
  
  return "not-asked";
};

// Verificar se notificações estão habilitadas com base nas preferências da API
export const isNotificationEnabled = async (): Promise<boolean> => {
  try {
    const token = localStorage.getItem("duas-vidas-token");
    if (!token) return false;

    const baseUrl = import.meta.env.VITE_BASE_URL || "http://localhost:3000";
    const response = await fetch(`${baseUrl}/users/me/preferences`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      // Fallback para localStorage se API falhar
      return getNotificationPermission() === "granted";
    }

    const data = await response.json();
    
    // Habilitado se pelo menos um dos toggles estiver ativo
    return data.notifyStatusUpdates || 
           data.notifyCityNews || 
           data.notifyGovernmentReplies || 
           data.notifyNeighborhoodNews;
  } catch (error) {
    console.error("Erro ao verificar preferências:", error);
    // Fallback para localStorage
    return getNotificationPermission() === "granted";
  }
};
